import React from 'react';
import { MapPin, LockOpen } from '@phosphor-icons/react';

export const DestinationPicker = ({ places = [], value, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="destination-picker">
    {places.map((p) => (
      <button key={p.id} type="button" onClick={() => onChange(p.id)} data-testid={`destination-${p.id}`}
              className={`px-3 py-1.5 rounded-full text-sm border transition-colors inline-flex items-center gap-1.5 ${
                value === p.id ? 'bg-white text-black border-white' : 'border-white/20 text-white/85 hover:bg-white/10'}`}>
        {p.hidden ? <LockOpen size={14} weight="bold" /> : <MapPin size={14} weight="fill" style={{ color: p.tint }} />}
        {p.name}
      </button>
    ))}
  </div>
);

export default DestinationPicker;
